import axios from "axios";
import debounce from "lodash-es/debounce";

export default class Search
{
    constructor()
    {


        let body = document.querySelector("body");

        /**
         * Moving towards a search "teacher" param based on the current user rather than "where we are"
         * @type {boolean}
         */
        // this.isTeacher = body.hasAttribute("data-for-teacher");
        this.isTeacher = AsGlobalSettings?.isProf ?? false;


        this.url = this.isTeacher ? "/profs/recherche" : "/recherche";
        this.isSearching = false;
        this.enableAutocomplete = false;

        this.canSearch = true;

        const urlSearchParams = new URLSearchParams( window.location.search );
        const params          = Object.fromEntries( urlSearchParams.entries() );

        this.isSearch = body.hasAttribute("data-is-search");

        if (this.isSearch && params.tri === undefined)
        {
            urlSearchParams.append("tri", "pertinence");
            window.location.search = urlSearchParams.toString();
        }

        this.bindEvents();


    }

    bindEvents ()
    {
        this.formSearch = document.querySelector("form#frmSearch");
        this.txtSearchInput = document.querySelector("#txt_search");
        this.txtNoResult = document.querySelector("#txt-no-results");

        if (!this.txtSearchInput)
            return;

        if (this.enableAutocomplete)
        {
            this.txtSearchInput.addEventListener("keyup", this.onSearchChange.bind(this))
        }
        this.formSearch.addEventListener("submit", this.onSubmit.bind(this))

        this.fctAutocomplete = this.autocomplete.bind(this);
        this.fctAutocompleteDebounced = debounce ( this.fctAutocomplete, 300);

        this.fctSelectAndSubmit = this.selectAndSubmit.bind(this);

        this.containerAutocomplete = document.querySelector("#container_autocomplete");
        this.ulAutocomplete = document.querySelector("#ul_autocomplete");
        this.liTemplateAutocomplete = document.querySelector("#template_li_autocomplete");

        if (!this.enableAutocomplete && this.containerAutocomplete)
        {
            this.containerAutocomplete.classList.add("d-none");
        }

        if (this.isSearch)
        {
            let scores = document.querySelectorAll(".score")

            scores.forEach ( score => score.addEventListener('click', this.explainScore.bind(this)))
        }
    }

    async explainScore (e)
    {
        const urlSearchParams = new URLSearchParams( window.location.search );
        const params          = Object.fromEntries( urlSearchParams.entries() );
        let doc_id = e.target.getAttribute("data-doc");

        let payload = {params, doc_id};
        let response = await axios.post("/endpoints/search/explain", payload);

        e.target.innerHTML = response.data;
    }

    onSearchChange (e)
    {
        let term = this.txtSearchInput.value;

        if (term.length > 2)
        {
            this.fctAutocompleteDebounced();
        }
    }

    async autocomplete ()
    {
        if (!this.canSearch)
        {
            return;
        }

        if (this.isSearching)
        {
            this.fctAutocompleteDebounced();
            return;
        }

        let term = this.txtSearchInput.value;
        let audiences = ["jeunes"];

        if (this.isTeacher)
        {
            audiences.push("profs")
        }

        let payload = { term, audiences };
        this.isSearching = true;

        let response = await axios.post("/endpoints/autocomplete", payload)

        this.fillAutocomplete(response.data);

        this.isSearching = false;
    }

    fillAutocomplete (results)
    {
        this.clearAutocomplete();

        if (results.length === 0)
        {
            this.ulAutocomplete.classList.add("d-none");
            this.txtNoResult.classList.remove("d-none");
            return;
        }

        this.ulAutocomplete.classList.remove("d-none");
        this.txtNoResult.classList.add("d-none");

        for (let i = 0; i < results.length; i++)
        {
            let term = results[i];

            let li = this.liTemplateAutocomplete.content.cloneNode(true).firstElementChild;

            this.ulAutocomplete.appendChild(li);

            if (li.querySelector)
            {
                let a = li.querySelector('a');
                a.innerText = term;
                a.attributes["data-term"] = term;

                a.addEventListener("click", this.fctSelectAndSubmit)
            }


        }

        this.containerAutocomplete.classList.remove("d-none");
    }

    clearAutocomplete (hide = false)
    {
        this.ulAutocomplete.innerHTML = "";

        if (hide)
        {
            this.containerAutocomplete.classList.add("d-none");
        }
    }

    selectAndSubmit (e)
    {
        e.preventDefault();

        this.canSearch = false;
        this.clearAutocomplete(true);

        let a = e.target;
        let term = a.attributes["data-term"];

        this.txtSearchInput.value = term;

        // 2024-03-06 MB : Client aimerait que les résultats soient par date et non pertinence
        // window.location.href = this.url + "?terme=" + term + "&tri=pertinence";
        window.location.href = this.url + "?terme=" + term + "&tri=date";

    }
    onSubmit (e)
    {
        e.preventDefault();

        let term = e.currentTarget[0].value;

        // 2024-03-06 MB : Client aimerait que les résultats soient par date et non pertinence
        // window.location.href = this.url + "?terme=" + term + "&tri=pertinence";
        window.location.href = this.url + "?terme=" + term + "&tri=date";
    }


}
